import React from "react";
import exhibition from "../images/exhibition.png";
import laptop from "../images/laptop.png";

const Exhibition = () => {
  return (
    <div>
      <div className="exhibition flex flex-col items-center py-20 space-y-10 md:hidden">
        <h1>EXHIBITION</h1>
        <img src={exhibition} alt="" className="h-[600px]" />
        <p className="subhead">
          Explore the virtual museum right from your comfort zone
        </p>
      </div>
      <div className=" py-20 space-y-10 w-full md-min:hidden">
        <h1 className="text-2xl text-center">OUR COLLECTION</h1>
        <div className="exhibition-md h-[294px] w-full flex flex-col items-center justify-center space-y-6">
          <div className="w-1/2">
            <img src={laptop} alt="" className="w-full" />
          </div>
          <h4 className="text-center">Feature only available on desktop</h4>
        </div>
      </div>
    </div>
  );
};

export default Exhibition;
